import { PermissionName } from 'c-sdk';

/**
 * Page permissions that other components gate links on. A leaf module (imports nothing but
 * c-sdk) so components can import them without pulling the page, and its import cycle, in.
 */

export const NewCampaignPagePermissions: PermissionName[] = [
    PermissionName.UniledportalCampaignCreate,
    PermissionName.UniledportalCampaignRead,
    PermissionName.UniledportalBuyerRead,
    PermissionName.DisplaysOwnersRead,
    PermissionName.UniledportalBuyer_costRead,
    PermissionName.DisplaysLine_itemsRead,
];

export const UpdateCampaignLineItemsPagePermissions: PermissionName[] = [
    PermissionName.UniledportalCampaignRead,
    PermissionName.UniledportalCampaignUpdate,
    PermissionName.UniledportalBudget_summary_line_itemRead,
    PermissionName.UniledportalBudget_summaryRead,
    PermissionName.UniledportalBudget_summary_line_itemRead,
];
